import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { getSeasonalLaunchBySlug } from '../../data/seasonalLaunches';
import { getLaunchPath } from '../../domain/seasonalLaunch';
import { fgtnQrBarHeight } from '../../utils/fgtnQrCard';
import FgtnQrArt from '../fgtn/FgtnQrArt';
import '../fgtn/Fgtn.css';

function qrSizeForViewport() {
  if (typeof window === 'undefined') return 520;
  const viewW = window.innerWidth;
  const viewH = window.innerHeight;
  const sample = Math.min(viewW, viewH);
  const bar = fgtnQrBarHeight(sample, 2, 'launch');
  return Math.max(240, Math.floor(Math.min(viewW, viewH - bar * 2)));
}

export default function SeasonalLaunchQrPage() {
  const { launchSlug } = useParams();
  const launch = getSeasonalLaunchBySlug(launchSlug);
  const share = launch?.shareAsset;
  const [qrSize, setQrSize] = useState(qrSizeForViewport);

  useEffect(() => {
    const update = () => setQrSize(qrSizeForViewport());
    update();
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, []);

  useEffect(() => {
    document.title = launch
      ? `${launch.brand} ${launch.launchSeason} QR | Angler Built`
      : 'Launch QR | Angler Built';
  }, [launch]);

  if (!launch || !share?.enabled || !share.shortUrl) {
    return (
      <div className="fgtn-qr-screen">
        <p>That share graphic is not available.</p>
        <Link to="/">Back to Angler Built</Link>
      </div>
    );
  }

  const extraLines = [share.supportingText, share.displayUrl].filter(Boolean);

  return (
    <div className="fgtn-qr-screen">
      <FgtnQrArt
        url={share.shortUrl}
        size={qrSize}
        title={share.headline}
        headline={share.headline}
        supportingText={share.supportingText}
        displayUrl={share.displayUrl}
        extraLines={extraLines}
        barColor={share.barColor}
        bottomBarColor={share.bottomBarColor}
        variant="launch"
      />
      <Link className="ab-launch-qr-back" to={getLaunchPath(launch)}>
        Back to guide
      </Link>
    </div>
  );
}
